export default __webpack_public_path__ + "images/flexible-banner-light.png";